export function capitalizeWords(str: string) {
  return str
    .toLowerCase() // Convert the entire string to lowercase
    .split(/[\s-_]+/) // Split by spaces, hyphens, or underscores
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
    .join(' '); // Join the words with spaces
}
